import { useTranslation } from "react-i18next";

import {
  DRIVER_FILE_DESTINATION_VALUES,
  VEHICLES_FOLDER_NAMING_VALUES
} from "../types";

export const useIntegrationsOptions = () => {
  const { t } = useTranslation();

  const driverFileDestinationOptions = [
    {
      name: t("Dialog##vehicle folder"),
      value: DRIVER_FILE_DESTINATION_VALUES.VehicleFolder
    },
    {
      name: t("Dialog##driver folder"),
      value: DRIVER_FILE_DESTINATION_VALUES.DriverFolder
    }
  ];

  const vehicleFolderNamingOptions = [
    {
      name: t("Dialog##imei"),
      value: VEHICLES_FOLDER_NAMING_VALUES.Imei
    },
    {
      name: t("Dialog##vehicle number"),
      value: VEHICLES_FOLDER_NAMING_VALUES.VehicleNumber
    }
  ];

  return {
    driverFileDestinationOptions,
    vehicleFolderNamingOptions
  };
};
